import { useEffect, useState, useContext } from "react";
import toast from "react-hot-toast";
import { ClientContext } from "ClientProvider";
import { useLocation } from "react-router-dom";
import PayinList from "./components/PayinList"
import AddBatchFile from "./components/AddBatchFile";
import { getPayin } from "api/graphQL_crypto"


export interface PayoutRowObj {
    id:any;
    createdAt:any;
    batchId: any;
    clientId: any;
    clientName: any;
    gatewayId:any;
    gatewayName:any;
    totalTransactions:any;
    gateway:any;
    totalAmount:any;
    currency:any;
    transations:any;
}

const CryptoPayin = () => {

    const [page, setPage] = useState<number>(1);
    const [payouts, setPayouts] = useState<PayoutRowObj[]>([]);
    const [totalpage, setTotalPage] = useState<number>(0);
    const [totalItems, setTotalItems] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(50);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchTexts, setSearchTexts] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { singleRoleData, setSingleRoleData , setFilter, filter } = useContext(ClientContext);
    const location = useLocation();
    const [clients, setClients] = useState();
    const [localFilters, setLocalFilters] = useState<any>({});
    const [clearClicked,setClearClick] = useState(0)


    const fetchPayouts = () => {
        let finalSearchText = ""
        if(location.state) {
        if (location.state?.search) {
            finalSearchText = location.state.search
            window.history.replaceState({}, document.title);
        }
        } else {
            finalSearchText = searchTexts;
        }
        const params = { page: page, per_page: pageSize, searchTexts: finalSearchText };
        if (pageSize === null || pageSize === undefined) {
        setIsLoading(false);
        return;
        }
        setIsLoading(true);
        getPayin(params)
        .then((data:any) => {
            if(data.status == "Error") {
                setPayouts([]);
                setTotalPage(1)
                setTotalItems(1)
                setCurrentPage(1)
            } else {
                setPayouts(data?.[0]);
                setTotalPage(data?.[1].total_pages);
                setTotalItems(data?.[1].total_items);
                setCurrentPage(data?.[1].current_page);
            }
        })
        .catch((err) => {
            setPayouts([]);
            setIsLoading(false);
        })
        .finally(() => {
            setIsLoading(false);
        });
    }

    useEffect(() => {
        fetchPayouts();
    }, [page, pageSize, searchTexts,clearClicked]);

    const serchboxValueChange = async (searchTerm: string) => {
        const search_txt = searchTerm || "";
    
        if (search_txt !== searchTexts && searchTexts !== "") {
          await setSearchTexts(search_txt);
          setPage(1);
          setCurrentPage(1);
        } else {
          await setSearchTexts(search_txt);
        }
    };

    const onClearClick = () => {
        setClearClick((prev) => {
          const newCount = prev + 1;
          return newCount;
        });
    };

    return (
        <>
            <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
                <AddBatchFile 
                fetchPayouts={fetchPayouts}
                />
            </div>
            <div className="mt-5">
                <PayinList 
                    tableData={payouts}
                    fetchPayouts={fetchPayouts}
                    isLoading={isLoading}
                    roleData={singleRoleData}
                    onValueChange={serchboxValueChange}
                    page={page}
                    setPage={setPage}
                    totalpage={totalpage}
                    totalItems={totalItems}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    setLocalFilters={setLocalFilters}
                    filterData={fetchPayouts}
                    localFilters={localFilters}
                    filter={filter}
                    setFilter={setFilter}
                    setClearClick={onClearClick}
                />
            </div>
        </>
    )
}

export default CryptoPayin;